module.exports = __webpack_public_path__ + "static/media/IEmpresa2.2c610d07.svg";